import { Component } from "@angular/core";
import {
  Platform,
  NavControllerBase,
  MenuController,
  App,
  AlertController,
} from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { LoginPage } from "../pages/login/login";
import { CustomersPage } from "../pages/customers/customers";
import { ApplicationApiProvider } from "../providers/application-api/application-api";
import { DataProvider } from "../providers/data/data";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { Keychain } from "@ionic-native/keychain";
import { SupportPage } from "../pages/support/support";
import { ResetnavProvider } from "../providers/resetnav/resetnav";
import { DemoProvider } from "../providers/demo/demo";
import { StarmsClientProvider } from "../providers/starms-client/starms-client";
import { BannersProvider } from "../providers/banners/banners";

export const LEGALDOCS = {
  corporate:
    "https://www.siemens-energy.com/global/en/general/corporate-information-se.html",
  "terms of use":
    "https://www.siemens-energy.com/global/en/general/terms-of-use.html",
  imprint: "https://www.siemens-energy.com/global/en/general/digital-id.html",
  privacy:
    "https://www.siemens-energy.com/global/en/general/privacy-notice.html",
};

@Component({
  templateUrl: "app.html",
})
export class MyApp {
  rootPage: any = LoginPage;
  showLoading = false;
  loadingMessage = "Explore the benefits of remote diagnostics";
  ready = false;
  user;
  visibilities = new Map<number, boolean>();

  constructor(
    private platform: Platform,
    splashScreen: SplashScreen,
    private appApi: ApplicationApiProvider,
    private menuController: MenuController,
    private app: App,
    public dataProvider: DataProvider,
    private inAppBrowser: InAppBrowser,
    private keychain: Keychain,
    private resetNav: ResetnavProvider,
    public demoProvider: DemoProvider,
    private starms: StarmsClientProvider,
    private bannersProvider: BannersProvider
  ) {
    this.platform.ready().then(() => {
      this.resetNav.event.subscribe((val) => {
        if (val === 1) {
          this.getNav().setRoot("auth");
        }
      });
    });
  }

  ngOnInit() {
    this.bannersProvider.fetchMessages();
    this.copyTokenToCookies();
  }

  uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  private copyTokenToCookies() {
    if (localStorage.getItem("token")) {
      const uui = this.uuidv4();
      document.cookie = `token=${localStorage.getItem("token")};path=/`; //Replaces the subdomain cookie
      document.cookie = `token=${localStorage.getItem("token")};path=/;domain=${
        window.location.origin
      }`; //Replaces the domain cookie
      document.cookie = `starmsSocketClientId=${uui};path=/`; //Replaces the subdomain cookie
      document.cookie = `starmsSocketClientId=${uui};path=/;domain=${window.location.origin}`; //Replaces the domain cookie
    }
  }
  getNav(): NavControllerBase {
    return this.app.getRootNav();
  }

  goToCustomersList(): void {
    this.menuController.close("nav");
    this.getNav().setRoot(CustomersPage);
  }

  logOut(): void {
    localStorage.clear();
    this.dataProvider.clearData();
    this.menuController.close("nav");
    if (this.platform.is("ios") && this.appApi.isNative()) {
      this.keychain.remove("token").then(() => {
        this.getNav().setRoot(LoginPage);
      });
    } else {
      this.getNav().setRoot(LoginPage);
    }
  }

  public openLegalDocs(
    option: "corporate" | "imprint" | "privacy" | "terms of use"
  ): void {
    this.inAppBrowser
      .create(LEGALDOCS[option], "_blank", {
        clearcache: "yes",
        location: "yes",
      })
      .show();
  }

  public support() {
    this.menuController.close("nav");
    this.getNav().push(SupportPage);
  }

  public license() {
    window.document.getElementById("license-box").style.display = "block";
  }

  public switchMode() {
    this.getNav().setRoot("switch", {
      mode: !this.demoProvider.demoMode,
    });
    this.menuController.close("nav");
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts